import Routes from './routes';

const MedicineOrderDetails = () => import(/* webpackChunkName: "medicine-order-details-chunk" */ '@/views/common/medicine-order-details/root-medicine-order-details');

export default {
  path: `/medicine-order/:${Routes.MEDICINE_ORDER_ID_PARAM}`,
  name: Routes.MEDICINE_ORDER,
  components: {
    overlay: MedicineOrderDetails,
  },
  props: {
    overlay: true
  },
  meta: {
    level: 2,
    isOverlay: true,
    root: Routes.SERVICES_ROUTE
  },
}
